import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject, combineLatest, of, Subscription } from 'rxjs';
import { distinctUntilChanged, filter, switchMap, take } from 'rxjs/operators';
import { fadeAnimation, listAnimation } from 'src/animations';
import { compare } from 'src/app/globals';
import { ContactPipe } from 'src/app/lib/customer/pipes/contact.pipe';
import { CustomerPipe } from 'src/app/lib/customer/pipes/customer.pipe';
import { UserPipe } from 'src/app/lib/shared/pipes/user.pipe';
import { WebsocketService } from 'src/app/services/websocket.service';
import { HISTORY_PROVIDER_SERVICE, IIssueProviderService } from '../../../interfaces';
import { IssueCategoryPipe } from '../../../pipes/issue-category.pipe';
import { IssuePriorityPipe } from '../../../pipes/issue-priority.pipe';
import { IssueStatusPipe } from '../../../../shared/pipes/issue-status.pipe';
import { IssueService } from '../../../services/issue.service';
import { IssueHistoryDialogComponentService } from './issue-history-dialog-component-service';

@Component({
  selector: 'app-issue-history-dialog',
  templateUrl: './issue-history-dialog.component.html',
  styleUrls: ['./issue-history-dialog.component.css'],
  providers: [
    { provide: HISTORY_PROVIDER_SERVICE, useClass: IssueHistoryDialogComponentService },
    UserPipe,
    IssueCategoryPipe,
    IssuePriorityPipe,
    IssueStatusPipe,
    ContactPipe,
    CustomerPipe
  ],
  animations: [ listAnimation, fadeAnimation ]
})
export class IssueHistoryDialogComponent implements OnDestroy, OnInit {

  public loading = new BehaviorSubject(false);
  
  private _currentIssueId: number = null;

  private _subscriptions: Subscription[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) private _data: { service: IIssueProviderService },
    @Inject(HISTORY_PROVIDER_SERVICE) public issueHistoryDialogComponentService: IssueHistoryDialogComponentService,
    private _issueService: IssueService,
    private _ref: MatDialogRef<IssueHistoryDialogComponent>,
    private _websocketService: WebsocketService
  ) { }

  close(){
    this._ref.close();
  }

  loadMore(){
    if(!this.loading.value && this.issueHistoryDialogComponentService.totalCount > this.issueHistoryDialogComponentService.audit.length) this.issueHistoryDialogComponentService.pageNumber.next(this.issueHistoryDialogComponentService.pageNumber.value+1);
  }

  ngOnDestroy(): void {
    for(let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this._subscriptions.push(...[
      this._websocketService.issueChanged$.pipe(filter(x => x.identifier === this._currentIssueId), switchMap(x => combineLatest([of(x), this.issueHistoryDialogComponentService.pageNumber, this.issueHistoryDialogComponentService.pageSize]).pipe(take(1)))).subscribe(([change, pageNumber, pageSize]) => this.updateAudit(change.identifier, pageNumber, pageSize)),
      combineLatest([
        this._data.service.issueId$.pipe(distinctUntilChanged()),
        this.issueHistoryDialogComponentService.pageNumber.pipe(distinctUntilChanged()),
        this.issueHistoryDialogComponentService.pageSize.pipe(distinctUntilChanged())
      ]).subscribe(([issueId, pageNumber, pageSize]) => this.updateAudit(issueId, pageNumber, pageSize))
    ]);
  }

  updateAudit(issueId: number, pageNumber: number, pageSize: number){
    this._currentIssueId = issueId;
    this.loading.next(true);
    this._issueService.getIssueChangeHistory(issueId, { pageNumber: pageNumber, pageSize: pageSize })
      .subscribe((result) => {
        this.loading.next(false);
        if(result.page.pageNumber <= 1) this.issueHistoryDialogComponentService.audit = [];
        this.issueHistoryDialogComponentService.audit = [...this.issueHistoryDialogComponentService.audit, ...result.content].sort((a, b) => compare(a.date, b.date, false));
        this.issueHistoryDialogComponentService.totalCount = result.totalItems;
      });
  }

}
